import { useState as p, useCallback as r } from "react";
import { toggleSelection as c } from "./toggle-selection.js";
const u = () => {
  const [e, t] = p(/* @__PURE__ */ new Set()), o = r((n, s) => {
    t((m) => c(m, n, s));
  }, []);
  return { openItemKeys: e, toggleOpenItem: o };
};
export {
  u as useOpenItemKeys
};
